import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from '@reach/router';

// for the full-screen loading page as everything happens
import Backdrop from '@mui/material/Backdrop';
import { usePolicyStreamGoogleAnalytics } from '../../../hooks/usePolicyStreamGoogleAnalytics';
import {
  GAEventNames,
  EventActions,
} from '../../../hooks/usePolicyStreamGoogleAnalytics/types';
import CircularProgress from '@mui/material/CircularProgress';

import { cannedAnswers } from './cannedAnswers';
import { generateAnswersFromQuestionsList } from './utility';

// types and classes
import { RouteComponentProps } from '@reach/router';
import { StoreState } from '../../../store';
import { useEnsureFormPresent } from '../../../hooks/useEnsureFormPresent';
import { POLICYSTREAM_FORMS } from '../constants';
import { policystreamStore } from '../../../store/policystreamStore';
import { useUsingCheapCharlieSettings } from '../../../hooks';

const {
  actions: { submitAnswersForForm },
} = policystreamStore;

export const PolicyStreamDemo = (_props: RouteComponentProps) => {
  const myAnalytics = usePolicyStreamGoogleAnalytics();

  const dispatch = useDispatch();
  const [readyToResume, setReadyToResume] = useState<boolean>(false);
  const usingCheapCharlie = useUsingCheapCharlieSettings();

  // Send Google Analytics event on component load
  useEffect(() => {
    myAnalytics?.triggerEvent(
      GAEventNames.Demo,
      EventActions.PageLoad,
      'PolicyStream Demo Page',
    );
  }, [myAnalytics]);

  // need to be dumped into the store
  const generalApplicationForm = useEnsureFormPresent({
    internalName: POLICYSTREAM_FORMS.applicationForm,
  });

  const answersPresent = useSelector(
    (state: StoreState) =>
      Object.keys(state.policystreamStore.formAnswers).length >= 1,
  );

  // check if we are manually passing in a whitelabel (this needs to be passed on to the quote)
  const paramWhitelabel = window.location.search.includes('whitelabel=')
    ? `?whitelabel=${new URLSearchParams(window.location.search).get(
        'whitelabel',
      )}`
    : '';

  // once the forms are loaded, load the answers
  useEffect(() => {
    if (generalApplicationForm) {
      for (let form of [generalApplicationForm]) {
        const matchedAnswersContainer = cannedAnswers.find(
          (answersContainer) =>
            answersContainer.internalName === form.internalName,
        );
        if (!matchedAnswersContainer) {
          continue;
        }

        const answers = generateAnswersFromQuestionsList(
          matchedAnswersContainer.answers,
          form.questionInstances,
        );

        dispatch(
          submitAnswersForForm({
            form,
            answers,
          }),
        );
      }
    }
  }, [generalApplicationForm]);

  // once everything is in state, indicate that we are about to resume the quote and set the demo flag
  useEffect(() => {
    if (generalApplicationForm && answersPresent) {
      setReadyToResume(true);
    }
  }, [generalApplicationForm, answersPresent, dispatch]);

  if (readyToResume) {
    navigate(`/insurance${paramWhitelabel}`);
  }

  if (!usingCheapCharlie) {
    navigate(`/insurance${paramWhitelabel}`);
  }

  if (!readyToResume) {
    return (
      <>
        <Backdrop open={true}>
          <CircularProgress color='secondary' size='2rem' />
        </Backdrop>
      </>
    );
  }

  return null;
};
